/*
 * FlexStucco — interactividad de la landing portada desde Lovable.
 * La landing original corre en React; aquí se reproduce el mismo comportamiento
 * sobre el HTML estático que genera Shopify, sin dependencias.
 */
(function () {
  'use strict';

  function money(pesos) {
    return '$' + Math.round(pesos).toLocaleString('en-US');
  }

  function swapClasses(el, from, to) {
    from.split(/\s+/).forEach(function (c) { if (c) el.classList.remove(c); });
    to.split(/\s+/).forEach(function (c) { if (c) el.classList.add(c); });
  }

  /* ------------------------------------------------ aparición al hacer scroll */
  function reveals() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------ parallax suave de la portada */
  function parallax() {
    var el = document.querySelector('[data-lv-parallax]');
    if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      var y = Math.min(window.scrollY, 600) * 0.06;
      el.style.transform = 'translate3d(0px, ' + y.toFixed(2) + 'px, 0px)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ------------------------------------------------ tarjeta de producto */
  function product() {
    var sec = document.querySelector('[data-lv-product]');
    if (!sec) return;
    var price = parseInt(sec.getAttribute('data-lv-price'), 10) / 100;

    var grid = sec.querySelector('[data-lv-finishes]');
    var clsOn = grid.getAttribute('data-cls-on');
    var clsOff = grid.getAttribute('data-cls-off');
    var check = sec.querySelector('[data-lv-check]');
    var label = sec.querySelector('[data-lv-finish-label]');
    var finishInput = sec.querySelector('[data-lv-finish-input]');

    grid.querySelectorAll('[data-lv-finish]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grid.querySelectorAll('[data-lv-finish]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          swapClasses(b, clsOn, clsOff);
        });
        btn.setAttribute('aria-pressed', 'true');
        swapClasses(btn, clsOff, clsOn);
        btn.insertBefore(check, btn.firstChild);
        var name = btn.getAttribute('data-lv-finish');
        label.textContent = name;
        finishInput.value = name;
        // La calculadora compra el mismo acabado que se eligió aquí
        document.querySelectorAll('[data-lv-finish-sync]').forEach(function (i) { i.value = name; });
      });
    });

    // Conservar el acabado al volver desde el carrito o recargar la pagina.
    var finishKey = 'flexstucco:acabado:' + sec.querySelector('input[name="id"]').value;
    var requestedFinish = new URLSearchParams(window.location.search).get('acabado');
    try { requestedFinish = requestedFinish || sessionStorage.getItem(finishKey); } catch (e) {}
    var restoreFinish = null;
    grid.querySelectorAll('[data-lv-finish]').forEach(function (btn) {
      var finishName = btn.getAttribute('data-lv-finish');
      if (finishName === requestedFinish) restoreFinish = btn;
      btn.addEventListener('click', function () {
        try { sessionStorage.setItem(finishKey, finishName); } catch (e) {}
        var finishUrl = new URL(window.location.href);
        if (finishUrl.searchParams.has('acabado')) {
          finishUrl.searchParams.set('acabado', finishName);
          window.history.replaceState(window.history.state, '', finishUrl.toString());
        }
      });
    });
    if (restoreFinish) restoreFinish.click();

    var qty = 1;
    var qtyEl = sec.querySelector('[data-lv-qty]');
    var qtyInput = sec.querySelector('[data-lv-qty-input]');
    var totalEl = sec.querySelector('[data-lv-total]');
    function renderQty() {
      qtyEl.textContent = qty;
      qtyInput.value = qty;
      totalEl.textContent = money(qty * price);
    }
    sec.querySelector('[data-lv-qty-minus]').addEventListener('click', function () {
      qty = Math.max(1, qty - 1); renderQty();
    });
    sec.querySelector('[data-lv-qty-plus]').addEventListener('click', function () {
      qty = Math.min(999, qty + 1); renderQty();
    });
    renderQty();
  }

  /* ------------------------------------------------ calculadora */
  function calculator() {
    var sec = document.querySelector('[data-lv-calc]');
    if (!sec) return;
    var price = parseInt(sec.getAttribute('data-lv-price'), 10) / 100;
    var rinde = parseFloat(sec.getAttribute('data-lv-rinde')) || 25;
    var input = sec.querySelector('[data-lv-calc-input]');
    var range = sec.querySelector('[data-lv-calc-range]');
    var countEl = sec.querySelector('[data-lv-calc-count]');
    var unitEl = sec.querySelector('[data-lv-calc-unit]');
    var totalEl = sec.querySelector('[data-lv-calc-total]');
    var btnEl = sec.querySelector('[data-lv-calc-btn]');
    var qtyInput = sec.querySelector('[data-lv-calc-qty]');
    var max = parseInt(range.getAttribute('max'), 10) || 5000;

    function render(m2) {
      var n = m2 > 0 ? Math.max(1, Math.ceil(m2 / rinde)) : 1;
      countEl.textContent = n;
      unitEl.textContent = n === 1 ? 'cubeta de 30kg' : 'cubetas de 30kg';
      totalEl.textContent = money(n * price);
      btnEl.textContent = 'Comprar ' + n + (n === 1 ? ' cubeta' : ' cubetas');
      qtyInput.value = n;
    }
    input.addEventListener('input', function () {
      var m2 = parseFloat(input.value);
      if (!(m2 >= 0)) m2 = 0;
      if (m2 > max) { m2 = max; input.value = max; }
      range.value = Math.max(1, m2);
      render(m2);
    });
    range.addEventListener('input', function () {
      input.value = range.value;
      render(parseFloat(range.value));
    });
    render(parseFloat(input.value) || 0);
  }

  /* ------------------------------------------------ antes / después deslizable */
  function compare() {
    var box = document.querySelector('[data-lv-compare]');
    if (!box) return;
    var range = box.querySelector('[data-lv-compare-range]');
    var clip = box.querySelector('[data-lv-clip]');
    var before = box.querySelector('[data-lv-before]');
    var line = box.querySelector('[data-lv-line]');
    function size() { before.style.width = box.clientWidth + 'px'; }
    function render() {
      var p = parseFloat(range.value);
      clip.style.width = p + '%';
      line.style.left = 'calc(' + p + '% - 1px)';
    }
    range.addEventListener('input', render);
    window.addEventListener('resize', size);
    size();
    render();
  }

  /* ------------------------------------------------ preguntas (acordeón de un solo panel) */
  function accordion() {
    var items = document.querySelectorAll('[data-lv-acc]');
    function setState(item, open) {
      var btn = item.querySelector('button');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var state = open ? 'open' : 'closed';
      [item, item.querySelector('h3'), btn, panel].forEach(function (el) {
        el.setAttribute('data-state', state);
      });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        panel.hidden = false;
        panel.style.setProperty('--radix-accordion-content-height', panel.scrollHeight + 'px');
      } else if (!panel.hidden) {
        panel.style.setProperty('--radix-accordion-content-height', panel.scrollHeight + 'px');
        setTimeout(function () {
          if (panel.getAttribute('data-state') === 'closed') panel.hidden = true;
        }, 200);
      }
    }
    items.forEach(function (item) {
      item.querySelector('button').addEventListener('click', function () {
        var wasOpen = item.getAttribute('data-state') === 'open';
        items.forEach(function (other) {
          if (other.getAttribute('data-state') === 'open') setState(other, false);
        });
        if (!wasOpen) setState(item, true);
      });
    });
  }

  /* ------------------------------------------------ desplazamiento a bloque completo
     Un ancla normal deja el inicio de la sección bajo el encabezado fijo y en laptops el
     bloque de compra queda cortado. Aquí se centra el bloque en el espacio visible
     (descontando encabezado y, en celular, la barra de compra); si no cabe, se alinea
     su parte de arriba justo bajo el encabezado. */
  function smartScroll() {
    var header = document.querySelector('header');
    function scrollToBlock(el) {
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var bar = document.querySelector('.fixed.inset-x-0.bottom-0');
      var barH = bar && getComputedStyle(bar).display !== 'none' ? bar.getBoundingClientRect().height : 0;
      var avail = window.innerHeight - headerH - barH;
      var r = el.getBoundingClientRect();
      var top = r.top, bottom = r.bottom;
      if (bottom - top + 24 > avail) {
        // No cabe completo: primero un bloque núcleo; si no hay, el tramo inicio→fin marcado
        var core = el.querySelector('[data-lv-scroll-core]');
        var st = el.querySelector('[data-lv-scroll-start]'), en = el.querySelector('[data-lv-scroll-end]');
        if (core) { r = core.getBoundingClientRect(); top = r.top; bottom = r.bottom; }
        else if (st && en) { top = st.getBoundingClientRect().top; bottom = en.getBoundingClientRect().bottom; }
      }
      var h = bottom - top;
      var pad = h + 24 <= avail ? (avail - h) / 2 : 12;
      window.scrollTo({ top: Math.max(0, window.scrollY + top - headerH - pad), behavior: 'smooth' });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var el = id && document.querySelector('[data-lv-scroll="' + id + '"]');
      if (!el) return;
      e.preventDefault();
      scrollToBlock(el);
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  /* ------------------------------------------------ cotizador de envío por código postal
     Reproduce las tarifas de Shopify: por estado y por cubeta. El estado sale de los dos
     primeros dígitos del código postal (rangos de SEPOMEX). */
  var CP_ESTADOS = [
    [1, 16, 'DF', 'Ciudad de México'], [20, 20, 'AGS', 'Aguascalientes'], [21, 22, 'BC', 'Baja California'],
    [23, 23, 'BCS', 'Baja California Sur'], [24, 24, 'CAMP', 'Campeche'], [25, 27, 'COAH', 'Coahuila'],
    [28, 28, 'COL', 'Colima'], [29, 30, 'CHIS', 'Chiapas'], [31, 33, 'CHIH', 'Chihuahua'],
    [34, 35, 'DGO', 'Durango'], [36, 38, 'GTO', 'Guanajuato'], [39, 41, 'GRO', 'Guerrero'],
    [42, 43, 'HGO', 'Hidalgo'], [44, 49, 'JAL', 'Jalisco'], [50, 57, 'MEX', 'Estado de México'],
    [58, 61, 'MICH', 'Michoacán'], [62, 62, 'MOR', 'Morelos'], [63, 63, 'NAY', 'Nayarit'],
    [64, 67, 'NL', 'Nuevo León'], [68, 71, 'OAX', 'Oaxaca'], [72, 75, 'PUE', 'Puebla'],
    [76, 76, 'QRO', 'Querétaro'], [77, 77, 'Q ROO', 'Quintana Roo'], [78, 79, 'SLP', 'San Luis Potosí'],
    [80, 82, 'SIN', 'Sinaloa'], [83, 85, 'SON', 'Sonora'], [86, 86, 'TAB', 'Tabasco'],
    [87, 89, 'TAMPS', 'Tamaulipas'], [90, 90, 'TLAX', 'Tlaxcala'], [91, 96, 'VER', 'Veracruz'],
    [97, 97, 'YUC', 'Yucatán'], [98, 99, 'ZAC', 'Zacatecas']
  ];
  function estadoDesdeCP(cp) {
    if (!/^\d{5}$/.test(cp)) return null;
    var n = parseInt(cp.slice(0, 2), 10);
    for (var i = 0; i < CP_ESTADOS.length; i++) {
      if (n >= CP_ESTADOS[i][0] && n <= CP_ESTADOS[i][1]) {
        return { code: CP_ESTADOS[i][2], name: CP_ESTADOS[i][3] };
      }
    }
    return null;
  }

  function quoteDialog() {
    var dlg = document.getElementById('lv-quote');
    var open = document.querySelector('[data-lv-calc-quote]');
    if (!dlg || !open || typeof dlg.showModal !== 'function') return;
    var d = dlg.dataset;
    var price = parseInt(d.price, 10) / 100;
    var lista = function (t) { return (t || '').split(',').map(function (x) { return x.trim().toUpperCase(); }); };
    var locales = lista(d.local), extendidos = lista(d.ext);
    var q = function (sel) { return dlg.querySelector(sel); };
    var cpIn = q('[data-lvq-cp]'), err = q('[data-lvq-error]'), res = q('[data-lvq-result]');
    var calcQty = document.querySelector('[data-lv-calc-qty]');
    var calcForm = document.getElementById('lv-calc-form');
    var finish = document.querySelector('[data-lv-finish-sync]');
    var n = 1, estado = null;

    function tarifa(code) {
      if (locales.indexOf(code) > -1) return parseFloat(d.rateLocal);
      if (extendidos.indexOf(code) > -1) return parseFloat(d.rateExt);
      return parseFloat(d.rateNac);
    }
    function render() {
      q('[data-lvq-n]').textContent = n;
      q('[data-lvq-acabado]').textContent = '· ' + (finish ? finish.value : 'Blanco Liso');
      q('[data-lvq-buylabel]').textContent = 'Comprar ' + n + (n === 1 ? ' cubeta' : ' cubetas');
      if (!estado) return;
      var t = tarifa(estado.code), sub = n * price, envio = n * t;
      q('[data-lvq-estado]').textContent = estado.name;
      q('[data-lvq-sub]').textContent = money(sub);
      q('[data-lvq-porcubeta]').textContent = '(' + money(t) + ' por cubeta)';
      q('[data-lvq-envio]').textContent = money(envio);
      q('[data-lvq-total]').textContent = money(sub + envio);
      q('[data-lvq-pickup]').textContent = money(sub);
    }
    function cotizar() {
      var cp = cpIn.value.replace(/\D/g, '');
      cpIn.value = cp;
      estado = estadoDesdeCP(cp);
      err.hidden = !!estado;
      res.hidden = !estado;
      render();
      // En pantallas bajas el total y el botón quedan abajo: se muestran solos
      if (estado) q('[data-lvq-buy]').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    open.addEventListener('click', function () {
      n = Math.max(1, parseInt(calcQty && calcQty.value, 10) || 1);
      render();
      dlg.showModal();
      setTimeout(function () { cpIn.focus(); }, 50);
    });
    q('[data-lvq-go]').addEventListener('click', cotizar);
    cpIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); cotizar(); } });
    cpIn.addEventListener('input', function () { if (cpIn.value.replace(/\D/g, '').length === 5) cotizar(); });
    q('[data-lvq-minus]').addEventListener('click', function () { n = Math.max(1, n - 1); render(); });
    q('[data-lvq-plus]').addEventListener('click', function () { n = Math.min(20, n + 1); render(); });
    q('[data-lvq-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });  // clic fuera de la tarjeta
    q('[data-lvq-buy]').addEventListener('click', function () {
      if (!calcForm || !calcQty) return;
      calcQty.value = n;
      calcForm.querySelector('[type=submit]').click();
    });
  }

  function init() {
    reveals();
    parallax();
    product();
    calculator();
    compare();
    accordion();
    smartScroll();
    quoteDialog();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
